
import React from 'react'
import { TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn } from 'material-ui/Table';

class OrderEvents extends React.Component {
  constructor(props) {
    super(props)
  }
  renderOrderEvents(events) {
    const orderEvents = events;
    const orderEventsDisplay = [];
    if (!_.isEmpty(orderEvents)) {
      _.map(orderEvents, (data, i) => {
        orderEventsDisplay.push(
          <TableRow key={i}>
            <TableRowColumn key={`${i}`} style={{ width: '20%' }}>{data.event.orderId}</TableRowColumn>
            <TableRowColumn key={`${i}`} style={{ width: '20%' }}>{data.event.name}</TableRowColumn>
            <TableRowColumn key={`${i}`} style={{ width: '20%' }}>{new Date(data.event.date).toLocaleString()}</TableRowColumn>
            <TableRowColumn key={`${i}`} style={{ width: '20%' }}>{data.event.type}</TableRowColumn>
            <TableRowColumn key={`${i}`} style={{ width: '20%' }}>{data.event.source}</TableRowColumn>
            <TableRowColumn key={`${i}`} style={{ width: '20%' }}>{data.event.details}</TableRowColumn>
          </TableRow>);
      });
    }
    return (
      <div>
        <table style={{ width: '100%', tableLayout: 'fixed' }}>
          <TableHeader
            displaySelectAll={false}
            adjustForCheckbox={false}
          >
            <TableRow selectable={false}>
              <TableHeaderColumn style={{ width: '20%' }}>OrderId</TableHeaderColumn>
              <TableHeaderColumn style={{ width: '20%' }}>Name</TableHeaderColumn>
              <TableHeaderColumn style={{ width: '20%' }}>Date</TableHeaderColumn>
              <TableHeaderColumn style={{ width: '20%' }}>Type</TableHeaderColumn>
              <TableHeaderColumn style={{ width: '20%' }}>Source</TableHeaderColumn>
              <TableHeaderColumn style={{ width: '20%' }}>Details</TableHeaderColumn>
            </TableRow>
          </TableHeader>
          <TableBody displayRowCheckbox={false}>
            {orderEventsDisplay}
          </TableBody>
        </table>
      </div>);
  }

  render() {
    const { events } = this.props
    return (
      <div>
        <h2>Order Events</h2>
        <div style={{ paddingLeft:'40px', paddingBottom: '20px' }}>
          {this.renderOrderEvents(events)}
        </div>
      </div>
    )
  }
}
export default OrderEvents;


// WEBPACK FOOTER //
// ./src/components/orders/Common/OrderEvents.js